import { END_POINT } from "constants/apiConstant";
import { apiPost, apiGet } from "../utils/apiUtils";
const { REGISTER_API, LOGIN_API, GET_ALL_COMPANY_API, CREATE_COMPANY_USER_API } = END_POINT;

export const registerCompany = async (payload) => {
  const response = await apiPost(REGISTER_API, payload);
  console.log("Register-response---", response);
  return response;
};

export const loginCompany = async (payload) => {
  const response = await apiPost(LOGIN_API, payload);
  console.log("Login-response---", response);
  return response;
};

export const verifyCompanyEmail = async (token) => {
  const response = await apiPost(`${END_POINT.VERIFY_EMAIL_API}${token}`, {});
  console.log("Verify-email-response---", response);
  return response;
};

export const getAllCompany = async () => {
  const response = await apiGet(GET_ALL_COMPANY_API);
  console.log("All-Company-response---", response);
  return response;
};

export const createCompanyUser = async (payload) => {
  const response = await apiPost(CREATE_COMPANY_USER_API, payload);
  console.log("Create-Company-User-response---", response);
  return response;
};

export const companyAdminLoginApi = async (payload) => {
  console.log("companyAdminLoginApi payload", { payload });
  const response = await apiPost(END_POINT.AUTHENTICATE_COMPANY_ADMIN_API, payload);
  return response;
};

export const saveBillingAPI = async (payload) => {
  const response = await apiPost(END_POINT.SAVE_BILLING, payload);
  return response;
};

export const getAccountAPI = async () => {
  const response = await apiGet(END_POINT.GET_ACCOUNT_API);
  return response;
};
